var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"padding-top":"250px"}},[_c('div',{staticStyle:{"text-align":"center"}},[_c('h2',[_vm._v("Page not found")])])])}]

export { render, staticRenderFns }